import { createContext, useContext, useEffect, useMemo, useReducer } from 'react';
import { PapsContext } from './PapsContext';
import { useRegDemo } from './useHelpers/useRegDemo';
import { regDataHandlers, regDataInitialState, regDataReducer } from './RegDemoContext';

/** AppContext */
export const RegDataContext = createContext();

/** Gls for the Event */
const RegDataProvider = (props) => {

  // papsContext
  const papsContext = useContext(PapsContext)
  const { paps_state } = papsContext ?? {}
  const { pathViews } = paps_state ?? {}
  const { events: settingsDocName } = pathViews ?? {}

  const isRegDemo = paps_state?.queryValues?.regdemo

  const initState = regDataInitialState({})
  const [regData_state, dispatch] = useReducer(regDataReducer, initState);
  const regData_handlers = useMemo(
    () => regDataHandlers(dispatch),
    [dispatch]
  );

  const rds = useRegDemo({ isRegDemo, settingsDocName, showToken: false })

  useEffect(() => {
    if (isRegDemo) {
      regData_handlers.handleSet_demoMode(rds)
    }
  }, [isRegDemo, rds]);

  const providerContext = () => <RegDataContext.Provider value={{ regData_state, regData_handlers }} >
    {props.children}
  </RegDataContext.Provider>

  return providerContext()
}

export default RegDataProvider